<template>
    <div class="site__body">
        <div class="block-space block-space--layout--spaceship-ledge-height"></div>
        <div class="block faq">
        <div class="container container--max--xl">
            <div class="document__content card">                     
                <div class="document__content">
                    <h1 class="not-found__title">404-Page Not Found</h1>
                    <h2>							
                        Sorry, we can't find that page.  
                    </h2>
                    <div class='block-space--layout--divider-20'></div>
                    <button class="btn btn-primary btn-sm"  @click="$router.go(-1)" style="margin-right: 10px;">
                        Return to the Previous Page
                    </button>
                    <router-link class="btn btn-primary btn-sm" to="/home">
                        Go To Home Page
                    </router-link>							  
                </div>                          							                       
            </div>                
            <div class="faq__footer">
                <div class="faq__footer-title">Please contact us if you have questions</div>
                <div class="faq__footer-subtitle">We are happy to answer any questions you may have.</div>
                <router-link to="/contact" class="btn btn-primary">Contact Us</router-link>
            </div>
        </div>
        </div>

        <div class="block-space block-space--layout--before-footer"></div>
    </div>
</template>

<script>
export default {
    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
    }
}
</script>